module.exports = __webpack_public_path__ + "static/media/BANNER_ESPIGA.d181561b.jpg";